module.exports = __webpack_public_path__ + "static/media/F_FI_20-05-20_Revestive_1_25mg.7c0bdaff.pdf";